const dtHandler = require('../../../../../components/dt/dt-handler')

export function fillItemsChatTable(result, htmlFc) {
    const mtItems = result.multiTables.find(
        table => table.tableName === 'purchase_vs_item'
    ) ?? [];
    const items = Array.isArray(mtItems?.data) ? mtItems.data : [];

    items.forEach(item => {
        item.item_name = getItemDisplayText(item?.item_id);
    });

    const data = items;

    const columns = [
          { key: 'item_name', label: 'Item', format: '', behavior: false, displayText: true },
          { key: 'qty', label: 'Qty', format: '', behavior: false, displayText: true },
          { key: 'total_price', label: 'Total', format: 'cash', behavior: false, displayText: true },
    ];

    const html = dtHandler.dtSimpleFc(data, columns);
    const cont = htmlFc.fullcontHTML.querySelector('#purchase-fullcont-extra-data');

    if (!cont) { return; }

    cont.innerHTML = '';
    cont.innerHTML = html;
}

function getItemDisplayText(itemIdRaw) {
    if (!itemIdRaw) { return ''; }

    try {
          const parsed = JSON.parse(itemIdRaw);

          if (Array.isArray(parsed) && parsed.length > 0) {
                const firstItem = parsed[0];
                return firstItem.displayText || firstItem.id || '';
          }
    } catch (error) {
          // Ignore parse errors and fallback to raw value.
    }

    return itemIdRaw;
}
